import { api } from '@/shared/api/client';
import type { AuthTokens, SignUpRequest } from '../model/dto';

export const postAuthSignUp = async (payload: SignUpRequest) => {
  const { data } = await api.post<AuthTokens>('/auth/signup/', payload);
  return data;
};
